import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { BasicStateTypes } from '../types/types';
import { ADMIN_BASE_URL, HEADERS } from '../utils/config';
import { AppSnackbar } from '../hooks/appSnackbar';

const initialState: BasicStateTypes = {
  loading: false,
  data: null,
  error: null,
};

const buildUrl = (id: number | null) => {
  return `${ADMIN_BASE_URL}/carousels${id ? `/${id}` : ''}`;
};

export const carouselCrud = createAsyncThunk(
  'carousel/carouselCrud',
  async ({ method, data, id }: { method: string, data: any, id: number | null }, { rejectWithValue }) => {
    try {
      const url = buildUrl(id);
      const config: AxiosRequestConfig = {
        method,
        url,
        headers: await HEADERS(),
        data,
      };
      const response = await axios(config);
      if (method === 'POST') {
        AppSnackbar({ type: 'success', message: 'Successfully created' });
      } else if (method === 'PUT' || method === 'PATCH') {
        AppSnackbar({ type: 'success', message: 'Successfully updated' });
      } else if (method === 'DELETE') {
        AppSnackbar({ type: 'success', message: 'Successfully deleted' });
      }
      return response.data;
    } catch (error: any) {
      if(error.code === "ERR_BAD_REQUEST"){
        AppSnackbar({ type: 'error', message: 'Network error!' })
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const carouselSlice = createSlice({
  name: 'carousel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(carouselCrud.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(carouselCrud.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(carouselCrud.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default carouselSlice.reducer;
